import {useEffect} from 'react';

import {useParams} from 'react-router-dom';

import {Stack} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';

import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useProductFeature} from '../hooks/useProductFeature.ts';
import {useProductFeaturesSelection} from '../hooks/useProductFeaturesSelection.ts';
import {useEditPageTools} from '../hooks/useEditPageTools';

import {useProductFeatures} from "../hooks/useProductFeatures.ts";


export const EditPage = () => {

    const {id: productId} = useParams();

    if (typeof productId === 'undefined') {
        throw new Error('productId is required parameter');
    }

    const {fetchRecords} = useProductFeatures();

    const {
        record: product,
        fetchRecord,
        updateRecord,
    } = useProductFeature(productId);

    const {handleClearSelection} = useProductFeaturesSelection();

    const {
        mode,
        tools,
    } = useEditPageTools();


    useEffect(() => {
        handleClearSelection();
    }, []);

    useEffect(() => {
        fetchRecords();
    }, []);

    useEffect(() => {
        fetchRecord();
    }, [productId]);

    if (!product) {
        return <PlatformLoader message='Loading product...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={product.name ? product.name : product.id}
            pageNavigation={<EditPageNavigation component={product}/>}
            tools={tools}
        >


            {mode === 'view' ?
                <Stack gap='lg'>
                    <Profile
                        record={product}
                    />

                    {/*
                    <AccountsPage/>
*/}

                </Stack>
                :
                <RecordForm
                    record={product}
                    handleSubmit={updateRecord}
                />}


        </FormPageLayout>
    );
};
